(() => {
  function initialize(root) {
    if (!root || root.dataset.kxoReady || !root.querySelector('.kxo-cards')) return;
    root.dataset.kxoReady = 'true';
    const scene = root.querySelector('.kxo-image');
    const rail = root.querySelector('.kxo-cards');
    const hole = root.querySelector('[data-kxo-cutout]');
    const cards = Array.from(rail.querySelectorAll('.kxo-card'));
    const preferred = ['basin','mirror','faucet','toilet','screen','shower','flush','drain','floor','wall','decor'];
    const rank = id => preferred.includes(id) ? preferred.indexOf(id) : preferred.length;
    cards.sort((a,b) => rank(a.dataset.product) - rank(b.dataset.product));
    cards.forEach(card => rail.append(card));
    const byId = new Map(cards.map(card => [card.dataset.product,card]));
    const regions = Array.from(scene.querySelectorAll('.kxo-regions a'));
    const markers = Array.from(scene.querySelectorAll('.kxo-marker'));
    const paths = new Map(regions.map(a => [a.dataset.product,a.querySelector('path').getAttribute('d')]));
    const filters = Array.from(root.querySelectorAll('[data-kxo-filter]'));
    const selectionLink = root.querySelector('[data-kxo-selection-link]');
    const popover = root.querySelector('.kxo-product-popover');
    const selectionName = popover.querySelector('[data-kxo-selection-name]');
    const selectionPrice = popover.querySelector('[data-kxo-selection-price]');
    const selectionWas = document.createElement('s');
    selectionWas.setAttribute('data-kxo-selection-was','');
    selectionWas.hidden = true;
    selectionPrice.before(selectionWas);
    const selectionUnit = popover.querySelector('[data-kxo-selection-unit]');
    const closePopover = popover.querySelector('.kxo-popover-close');
    const previous = root.querySelector('[data-kxo-prev]');
    const next = root.querySelector('[data-kxo-next]');
    const counter = root.querySelector('[data-kxo-count]');
    const announcement = root.querySelector('[data-kxo-announcement]');
    let selected = null;
    let group = 'all';
    let displayed = null;
    function positionPopover() {
      if (popover.hidden || matchMedia('(max-width:749px)').matches) return;
      const marker = markers.find(el => el.dataset.product === displayed);
      if (!marker) return;
      const bounds = scene.getBoundingClientRect();
      const target = marker.getBoundingClientRect();
      const x = target.left + target.width / 2 - bounds.left;
      const y = target.top + target.height / 2 - bounds.top;
      const width = popover.offsetWidth;
      const height = popover.offsetHeight;
      const left = x + 24 + width <= bounds.width - 12 ? x + 24 : x - width - 24;
      popover.style.left = Math.max(12,Math.min(left,bounds.width-width-12))+'px';
      popover.style.top = Math.max(12,Math.min(y-height/2,bounds.height-height-12))+'px';
    }
    function show(id) {
      const card = byId.get(id);
      displayed = card ? id : null;
      scene.classList.toggle('has-selection',Boolean(card));
      hole.setAttribute('d',card ? paths.get(id) || '' : '');
      [...markers,...regions].forEach(el => el.classList.toggle('is-active',Boolean(card) && el.dataset.product === id));
      popover.hidden = !card;
      if (card) {
        selectionLink.href = card.href;
        selectionName.textContent = card.querySelector('.kxo-card__name').textContent.trim();
        selectionPrice.textContent = card.querySelector('.kxo-card__price b').textContent.trim();
        const was = card.querySelector('.kxo-card__price s')?.textContent.trim() || '';
        selectionWas.textContent = was;
        selectionWas.hidden = !was;
        selectionWas.setAttribute('aria-label','Предишна цена: '+was);
        selectionUnit.textContent = card.querySelector('.kxo-card__price small')?.textContent.trim() || '';
        positionPopover();
      }
    }
    function visibleCards() { return Array.from(rail.children).filter(card => !card.hidden); }
    function updateNavigation() {
      const visible = visibleCards();
      const bounds = rail.getBoundingClientRect();
      const onScreen = visible.filter(card => {const r=card.getBoundingClientRect();return r.right>bounds.left+2 && r.left<bounds.right-2;});
      const start = onScreen.length ? visible.indexOf(onScreen[0])+1 : 0;
      const end = onScreen.length ? visible.indexOf(onScreen[onScreen.length-1])+1 : 0;
      counter.textContent = start+'–'+end+' / '+visible.length;
      previous.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    function render(resetScroll = false) {
      cards.forEach(card => {
        card.hidden = group !== 'all' && card.dataset.group !== group;
        const active = card.dataset.product === selected;
        if (active) card.setAttribute('aria-current','true'); else card.removeAttribute('aria-current');
        card.querySelector('.kxo-selected-note').hidden = !active;
      });
      markers.forEach(marker => {
        marker.setAttribute('aria-pressed',String(marker.dataset.product === selected));
        marker.setAttribute('aria-expanded',String(marker.dataset.product === selected));
        marker.setAttribute('aria-controls',popover.id);
      });
      filters.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.kxoFilter === group)));
      if (resetScroll) rail.scrollLeft = 0;
      show(selected);
      requestAnimationFrame(updateNavigation);
    }
    function select(id) {
      if (!byId.has(id)) return;
      selected = id;
      render();
      announcement.textContent = 'Избрано от банята: '+selectionName.textContent+', '+selectionPrice.textContent+' '+selectionUnit.textContent+'. Отворете връзката „Вижте продукта“ за подробности.';
    }
    function dismissPopover(restoreFocus) {
      const marker = markers.find(el => el.dataset.product === selected);
      selected = null;
      render();
      if (restoreFocus && marker) marker.focus({preventScroll:true});
    }
    closePopover.addEventListener('click',()=>dismissPopover(true));
    root.addEventListener('keydown',event=>{
      if(event.key==='Escape' && !popover.hidden){event.preventDefault();dismissPopover(true);}
    });
    [...markers,...regions].forEach(el => {
      el.addEventListener('click',event => {if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();select(el.dataset.product);});
      el.addEventListener('keydown',event=>{
        if(event.key==='Tab' && !event.shiftKey && selected===el.dataset.product && !popover.hidden){event.preventDefault();selectionLink.focus();}
        if(el.tagName.toLowerCase()==='a' && event.key===' '){event.preventDefault();select(el.dataset.product);}
      });
    });
    cards.forEach(card => {
      card.addEventListener('pointerenter',()=>{if(matchMedia('(hover:hover)').matches)show(card.dataset.product);});
      card.addEventListener('pointerleave',()=>show(selected));
      card.addEventListener('focus',()=>show(card.dataset.product));
      card.addEventListener('blur',()=>show(selected));
    });
    filters.forEach(button => button.addEventListener('click',()=>{
      group = button.dataset.kxoFilter;
      render(true);
    }));
    function move(direction) {
      const card = visibleCards()[0];
      if(!card)return;
      const gap = parseFloat(getComputedStyle(rail).gap)||0;
      const step = card.getBoundingClientRect().width+gap;
      const count = Math.max(1,Math.floor((rail.clientWidth+gap)/step));
      rail.scrollBy({left:direction*step*count,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',updateNavigation,{passive:true});
    const allButton=root.querySelector('[data-kxo-all]');
    const allList=root.querySelector('.kxo-all-products');
    allButton.addEventListener('click',()=>{allList.hidden=!allList.hidden;allButton.setAttribute('aria-expanded',String(!allList.hidden));});
    const observer=new ResizeObserver(()=>{updateNavigation();positionPopover();});
    observer.observe(rail);
    observer.observe(scene);
    observer.observe(popover);
    root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
    render();
  }
  document.querySelectorAll('[data-kxo-premium]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-kxo-premium]').forEach(initialize));
})();
